


































































import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    pageDataType,
    JobPageDataType
} from "../types";
import {
    FETCH_JOB_DATA,
} from "../store/actions.names";
import {
    SET_JOB_CURRENT_PAGE,
    SET_JOB_DATA,
    CURRENT_PAGE_ERROR,
    SET_JOB_PARENT_PAGE
} from "../store/mutations.names";
import {
    API_URL
} from "../global";
import {
    pageData
} from "@/store/pageData";
import axios from 'axios';
@Component({
    name: "JobList",
    components: {}
})
export default class JobList extends Vue {
    @Prop() public pageData!: pageDataType;
    @Getter("jobData") public jobData!: JobPageDataType[];
    @Getter("pageType") public pageType!: string | null;
    @Action(FETCH_JOB_DATA) public fetchJobData: any;
    @Mutation(SET_JOB_CURRENT_PAGE) public[SET_JOB_CURRENT_PAGE]: any;

    public mounted() {
        this[FETCH_JOB_DATA]();
        // console.log(this);
    }
}
